// 작업 상태 판정 + 컬러 시스템 (사이드바·WBS·통계 카드 공통)

export const STATUS = {
  done:     { key: "done",     label: "완료",   color: "#16a34a", bg: "#dcfce7", border: "#86efac" },
  progress: { key: "progress", label: "진행중", color: "#2563eb", bg: "#dbeafe", border: "#93c5fd" },
  planned:  { key: "planned",  label: "예정",   color: "#9ca3af", bg: "#f3f4f6", border: "#e5e7eb" },
  delayed:  { key: "delayed",  label: "지연",   color: "#ef4444", bg: "#fee2e2", border: "#fecaca" },
}

const dayOnly = (d) => {
  const dt = d instanceof Date ? d : new Date(d)
  return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate())
}

// 기준일 시점의 "목표 진척률" (0~100)
export const computeBaselineProgress = (startDate, endDate, refDate) => {
  if (!startDate || !endDate) return 0
  const start = dayOnly(startDate).getTime()
  const end = dayOnly(endDate).getTime()
  const ref = refDate ? dayOnly(refDate).getTime() : dayOnly(new Date()).getTime()
  if (isNaN(start) || isNaN(end) || end <= start) return 0
  if (ref <= start) return 0
  if (ref >= end) return 100
  return Math.round(((ref - start) / (end - start)) * 100)
}

// 작업 하나의 상태 판정
export const getTaskStatus = (task, refDate) => {
  const progress = Number(task.progress || 0)
  if (progress >= 100) return STATUS.done
  if (!task.startDate || !task.endDate) return STATUS.progress
  const ref = refDate ? dayOnly(refDate) : dayOnly(new Date())
  const start = dayOnly(task.startDate)
  const end = dayOnly(task.endDate)
  if (ref < start) return STATUS.planned
  if (ref > end) return STATUS.delayed
  const baseline = computeBaselineProgress(task.startDate, task.endDate, ref)
  if (progress < baseline - 5) return STATUS.delayed
  return STATUS.progress
}

// 작업 묶음 통계 — 통계 카드용
export const summarizeTasks = (tasks, refDate) => {
  const list = Array.isArray(tasks) ? tasks : []
  const result = {
    total: list.length,
    done: 0, progress: 0, planned: 0, delayed: 0,
    avgActual: 0, avgBaseline: 0,
  }
  if (!list.length) return result
  let actualSum = 0, baselineSum = 0
  for (const t of list) {
    const p = Number(t.progress || 0)
    actualSum += p
    baselineSum += computeBaselineProgress(t.startDate, t.endDate, refDate)
    const s = getTaskStatus(t, refDate)
    if (s === STATUS.done) result.done++
    else if (s === STATUS.delayed) result.delayed++
    else if (s === STATUS.planned) result.planned++
    else result.progress++
  }
  result.avgActual = Math.round(actualSum / list.length)
  result.avgBaseline = Math.round(baselineSum / list.length)
  return result
}
